import Focus from '../util/Focus';

export default {
	init() {
		setupOffCanvasMenuToggle();
		setupSubMenus();
	}
}

let $body = null,
	$ocm  = null,
	trapped = null,
	animSpeed = 300;

function setupOffCanvasMenuToggle() {
	$body = $('html body')
	$ocm = $('#off-canvas-menu');

	$body.find('#ocm-toggle').on('click', (e) => {
		e.preventDefault();
		toggleOffCanvasMenu();
	});

	$ocm.find('a.close-ocm').on('click', (e) => {
		e.preventDefault();
		closeOffCanvasMenu();
	});
}

function toggleOffCanvasMenu() {
	if (!$ocm.hasClass('animating')) {
		if ($body.hasClass('ocm-open')) {
			closeOffCanvasMenu();
		} else {
			openOffCanvasMenu();
		}
	}
}

function openOffCanvasMenu() {
	$ocm.addClass('animating');
	$body.addClass('ocm-open');

	$ocm.css('display', 'block');
	$ocm.animate({
		left: 0,
		right: 0
	}, animSpeed, () => {
		$ocm.removeClass('animating');
		$body.removeClass('ocm-opening');
	});

	trapped = Focus.trapFocus($ocm.get(0)); // Trap focus in OCM
}

function closeOffCanvasMenu() {
	$ocm.addClass('animating');
	$body.removeClass('ocm-open');

	$ocm.animate({
		left: '100vw',
		right: '-100vw'
	}, animSpeed, () => {
		$ocm.removeClass('animating');
		$body.removeClass('ocm-opening');

		setTimeout(() => {
			$ocm.css('display', 'none');
		}, animSpeed * 2);
	});

	if (trapped) {
		trapped.onClose(); // Clean up the trapping of focus
	}
}

function setupSubMenus() {
	let $menu = $ocm.find('ul.nav'),
		$parentItems = $menu.find('li.menu-item-has-children');

	$parentItems.each((index, item) => {
		let $li = $(item)

		if (!$li.hasClass('sub-menu-initialized')) {
			setupSubMenuTriggers($li);
		}
	});
}

function setupSubMenuTriggers($parentLi) {
	let $triggerLink = $parentLi.find('a').first();

	$triggerLink.on('click', function(e) {
		e.preventDefault();

		toggleSubMenu($parentLi);
	})
}

function toggleSubMenu($parentLi) {
	if ($parentLi.hasClass('animating')) {
		return;
	}

	$parentLi.addClass('animating');

	if ($parentLi.hasClass('open-sub-menu')) {
		closeSubMenu($parentLi);
	} else {
		openSubMenu($parentLi);
	}

	setTimeout(() => {
		$parentLi.removeClass('animating');
	}, animSpeed)
}

function openSubMenu($parentLi) {
	let $subMenu = $parentLi.find('ul.sub-menu').first();

	$parentLi.removeClass('closed-sub-menu').addClass('open-sub-menu');

	$subMenu.slideDown(animSpeed);
}

function closeSubMenu($parentLi) {
	let $subMenu = $parentLi.find('ul.sub-menu').first();

	$parentLi.removeClass('open-sub-menu').addClass('closed-sub-menu');

	$subMenu.slideUp(animSpeed);
}
